export default __webpack_public_path__ + "static/jed-furniss-874d776552efcab0bf44b186e5ad01ae.png";